import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Component for managing page-specific meta tags
 * Uses react-helmet-async for dynamic meta tag management
 */
const SEO = ({
  title = 'Idris Express - Fast Courier & Delivery Services UK',
  description = 'Professional courier services across the UK & Europe. Same-day, next-day delivery, multi-drop services & storage solutions.',
  keywords = 'courier service, delivery uk, same day delivery, next day delivery, parcel delivery',
  canonicalUrl = 'https://idrisexpressltd.co.uk',
  ogImage = 'https://idrisexpressltd.co.uk/assets/og-image.jpg',
  ogType = 'website',
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={canonicalUrl} />
      <meta property="twitter:title" content={title} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
    </Helmet>
  );
};

export default SEO;
